// Aba Caixas anteriores: filtros, página e o que o servidor devolve.
// Desde 25/10/2026 (dono) a aba alcança todos os caixas fechados, 10 por página:
// filtro, contagem e números do topo são do servidor (GET /caixas/anteriores),
// que classifica o resultado igual a `resultadoDoCaixa`.
// Resultado: "bateu" ou "diferenca" (faltou ou sobrou).
// `versao` muda quando a tela recarrega (fechou um caixa, tocou em Atualizar).

import { useEffect, useState } from "react";
import { toast } from "sonner";

import { caixaApi } from "../api/caixaApi";

const VAZIO = { itens: [], total: 0, total_geral: 0, resumo: null };

export function useFiltrosHistorico(versao) {
  const [filtroData, setFiltroData] = useState("");
  const [filtroBusca, setFiltroBusca] = useState("");
  const [buscaEnviada, setBuscaEnviada] = useState("");
  const [filtroResultado, setFiltroResultado] = useState("");
  const [pagina, setPagina] = useState(1);
  const [porPagina, setPorPagina] = useState(10);
  const [dados, setDados] = useState(VAZIO);
  const [carregando, setCarregando] = useState(true);

  // A busca vai ao servidor 300 ms depois da última tecla
  useEffect(() => {
    const t = setTimeout(() => setBuscaEnviada(filtroBusca.trim()), 300);
    return () => clearTimeout(t);
  }, [filtroBusca]);

  // Filtro novo volta para a primeira página
  useEffect(() => { setPagina(1); }, [filtroData, buscaEnviada, filtroResultado, porPagina]);

  useEffect(() => {
    let vivo = true;
    setCarregando(true);
    caixaApi.anteriores({ pagina, por_pagina: porPagina, dia: filtroData, busca: buscaEnviada, resultado: filtroResultado })
      .then((r) => { if (vivo) setDados(r || VAZIO); })
      .catch(() => { if (vivo) toast.error("Erro ao carregar os caixas anteriores"); })
      .finally(() => { if (vivo) setCarregando(false); });
    return () => { vivo = false; };
  }, [pagina, porPagina, filtroData, buscaEnviada, filtroResultado, versao]);

  const limparFiltros = () => {
    setFiltroData("");
    setFiltroBusca("");
    setFiltroResultado("");
  };

  return {
    filtroData,
    filtroBusca,
    setFiltroData,
    setFiltroBusca,
    filtroResultado,
    setFiltroResultado,
    pagina,
    setPagina,
    porPagina,
    setPorPagina,
    itens: dados.itens || [],
    total: dados.total || 0,
    totalGeral: dados.total_geral || 0,
    resumo: dados.resumo,
    carregando,
    limparFiltros,
    temFiltroAtivo: Boolean(filtroData || filtroBusca || filtroResultado),
  };
}
